/*eslint-disable*/
import React, { useState } from 'react';
import BoundariesSection from 'mapcontrols/sections/BoundariesSection/BoundariesSection';
import DemographicsSection from 'mapcontrols/sections/DemographicsSection/DemographicsSection';
import ReferenceLayersSection from 'mapcontrols/sections/ReferenceLayersSection/ReferenceLayersSection';
import * as Styled from './styles';
import { AZ_ACCOUNT_MAP_SECTIONS } from 'mapcontrols/constants';

const SwatchLegendItem = ({ backgroundColor, borderColor, text, type = 'circle', style = {} }) => (
  <>
    <div
      className={`leaflet-biglayerpanel-layer-swatch leaflet-biglayerpanel-layer-swatch-${type}`}
      style={{ backgroundColor, borderColor, ...style }}
    ></div>
    {text}
    <br />
  </>
);

const ManageAssignmentsMapPanel = ({
  onToggle,
  isExpanded = true,
  mapLegendImages = {},
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeLayerIds = [],
  onLayerToggle = () => {},
  calcPolygonSelections = [],
  calcPolygonLabelSelections = [],
  onCalculablePolygonChange = () => {},
  onCalculablePolygonLabelChange = () => {},
  demographicSelection = null,
  onDemographicChange = () => {},
  campaignId = '',
}) => {
  const togglePanel = () => {
    if (onToggle) onToggle(!isExpanded);
  };
  const [activeSections, setActiveSections] = useState(AZ_ACCOUNT_MAP_SECTIONS);

  const onSectionToggle = (id) => {
    setActiveSections((state) => ({ ...state, [id]: !state[id] }));
  };
  return (
    <Styled.MapFeaturesWrapper>
      <Styled.Panel
        className="leaflet-biglayerpanel-header"
        tabIndex="0"
        aria-label="Open or close this panel"
        id="map-biglayerpanel-header"
        onClick={togglePanel}
      >
        <button
          aria-expanded={isExpanded}
          className="leaflet-biglayerpanel-togglebutton"
          aria-controls="map-biglayerpanel-panel"
          id="map-biglayerpanel-togglebutton"
          tabIndex="-1"
          aria-hidden="true"
        >
          &times;
        </button>
        Map Features
      </Styled.Panel>

      <div
        className="leaflet-biglayerpanel-panel"
        id="map-biglayerpanel-panel"
        aria-labelledby="map-biglayerpanel-togglebutton"
        style={{ display: isExpanded ? 'block' : 'none' }}
      >
        {campaignId && (
          <Styled.SwatchLegendSection>
            <Styled.SwatchLegendsContainer>
              <Styled.SwatchLegendWrapper>
                <SwatchLegendItem backgroundColor="#913fdf" borderColor="#000000" />
                <span>Assigned retailers</span>
              </Styled.SwatchLegendWrapper>
              <Styled.SwatchLegendWrapper>
                <SwatchLegendItem backgroundColor="#f28e36" borderColor="#000000" />
                <span>Not assigned retailers</span>
              </Styled.SwatchLegendWrapper>
            </Styled.SwatchLegendsContainer>
            <em style={{ fontSize: '85%' }}>Note: This view is only available at close-up levels.</em>
          </Styled.SwatchLegendSection>
        )}
        <div className="leaflet-biglayerpanel-accordion">
          <ReferenceLayersSection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
            mapLegendImages={mapLegendImages}
          />
          <BoundariesSection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            onCalculablePolygonChange={onCalculablePolygonChange}
            onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
            calcPolygonSelections={calcPolygonSelections}
            calcPolygonLabelSelections={calcPolygonLabelSelections}
            calculableBoundaryLayers={calculableBoundaryLayers}
          />
          <DemographicsSection
            calculableBoundaryLayers={calculableBoundaryLayers}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            demographicSelection={demographicSelection}
            onDemographicChange={onDemographicChange}
          />
        </div>
      </div>
    </Styled.MapFeaturesWrapper>
  );
};

export default ManageAssignmentsMapPanel;
